// extracted by mini-css-extract-plugin
export default {"contactDetailsContainer":"contactdetails_contactDetailsContainer__PtcKd","contactMessage":"contactdetails_contactMessage__cyTt4","titleText":"contactdetails_titleText__NcWPz"};